export default __webpack_public_path__ + "static/media/parkingplace2.3f5269e1.jpg";